module.exports = __webpack_public_path__ + "static/media/interagency-logo.752ee9e8.jpg";